






























import { Beneficio } from '@/model/beneficio';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import beneficioService from '@/api/beneficio.service';
import { BeneficioFilter } from '@/model/filter/beneficio-filter';
import { Endereco } from '@/model/endereco';
import { TipoDeficiencia } from '@/model/tipo-deficiencia';
import Multiselect from 'vue-multiselect';

@Component
export default class BeneficioComponent extends Vue {

    @Prop() public isExibirProp!: Boolean;
    @Prop() public showCollapseProp!: Boolean;
    @Prop() public enderecoProp!: Endereco;
    @Prop() public beneficiosProp!: Array<Beneficio>;
    @Prop() public tiposDeficiencia!: Array<TipoDeficiencia>;

    public isExibir: Boolean = false;
    public showContent: Boolean = false;

    public beneficios: Array<Beneficio> = Array.of();
    public beneficiosSelecionados: Array<Beneficio> = Array.of();

    constructor() {
        super();
        this.$parent.$on('openFieldset', this.openFieldset);
        this.beneficios = Array.of();
        this.beneficiosSelecionados = this.beneficiosProp;
        this.carregaBeneficios();
        if (this.showCollapseProp != undefined) {
            this.showContent = this.showCollapseProp;
        }
    }
    
    @Watch('tiposDeficiencia')
    async carregarRescursosLogado() {
        this.carregaBeneficios();
    }

    public async carregaBeneficios() {
        let listaDesficienciasGerais: Number[] = [];        

        let tiposDefGerais: Array<TipoDeficiencia> = [];

        let filter = new BeneficioFilter("", true, true, tiposDefGerais);
        
        const retorno = await beneficioService.listarBeneficios(filter, false);
        if (retorno != null){
            this.beneficios = retorno.registros;
            this.beneficiosSelecionados = this.beneficiosSelecionados.filter(
                selec => this.beneficios.filter(ben => ben.id === selec.id).length !== 0)
            this.$emit('atualizarBeneficio', this.beneficiosSelecionados)
        }
    }

    public openFieldset(value) {
        if (this.$validator.errors.count() > 0) {
            this.showContent = value;
        }
    }
}
